const downloadedFiles = {
  '404.data.background_illustration': true,
  '404.data.illustration': true,
  'contact.data.logo_image.logo': true,
  'definition.data.illustration': true,
  'definition.data.recommanded_section.item_picture': true,
  'event.data.illustration': true,
  'event.data.event_slides.event_slide': true,
  'event_gallery.data.illustration': true,
  'author.data.profile_picture': true,
  'category.data.illustration': true,
  'contact.data.body.quick_presentation.primary.presentation_picture': true,
  'contact.data.body.quick_presentation_list.items.presentation_picture': true,
  'contact.data.body.big_cta_homepage.primary.big_cta_homepage_illustration': true,
  'event.data.body.image.primary.image_content': true,
  'homepage.data.illustration': true,
  'homepage_web.data.body.questions_type.items.questions_type_card_illustration': true,
  'homepage_web.data.body.interactive_vertical.items.interactive_vertical_cta_illustration': true,
  'homepage_web.data.body.interactive_horizontal.items.interactive_horizontal_illustration': true,
  'homepage_web.data.body.social_proof.items.social_proof_logo': true,
  'homepage_web.data.body.testimonial_carousel.primary.testimonial_carousel_illustration': true,
  'homepage_web.data.body.testimonial_carousel.items.testimonial_carousel_person': true,
  'homepage_web.data.body.testimonial_carousel.items.testimonial_carousel_logo': true,
  'homepage_web.data.body.horizontal_card_cta.items.horizontal_card_illustration': true,
  'homepage_web.data.body.big_cta_homepage.primary.big_cta_homepage_illustration': true,
  'homepage_web.data.body.expendable_presentation.primary.exp_pres_illustration': true,
  'homepage_web.data.body.main_hero_with_illustration.primary.main_hero_illustration': true,
  'homepage_web.data.body.presentation_list.items.presentation_illustration': true,
  'homepage_web.data.body.quote_tile_carousel.items.quote_illustration': true,
  'homepage_web.data.body.social_proof_monochrome.items.monochrome_social_proof_logo': true,
  'homepage_web.data.body.step_list_with_cta.items.step_list_illustration': true,
  'homepage_web.data.body.three_card_tabs.items.card_illustration': true,
  'homepage_web.data.body.three_presentation_tabs.items.presentation_tabs_content_illustration': true,
  'homepage_web.data.body.tile_grid_with_illustration.items.tile_illustration': true,
  'homepage_web.data.body.feature_presentation_homepage.items.feature_picture': true,
  'homepage_web.data.body.quick_presentation.items.feature_picture': true,
  'homepage_web.data.body.quick_presentation.primary.presentation_picture': true,
  'page.data.body.testimonial_carousel.primary.testimonial_carousel_illustration': true,
  'page.data.body.testimonial_carousel.items.testimonial_carousel_person': true,
  'page.data.body.testimonial_carousel.items.testimonial_carousel_logo': true,
  'page.data.body.big_cta_homepage.primary.big_cta_homepage_illustration': true,
  'page.data.body.basic_header.primary.basic_illustration': true,
  'page.data.body.block_list.items.block_illustration': true,
  'page.data.body.cta_card.primary.cta_card_picture': true,
  'page.data.body.cta_with_illustration.primary.cta_with_illustration_illustration': true,
  'page.data.body.feature_presentation.primary.presentation_picture': true,
  'page.data.body.feature_presentation.items.feature_picture': true,
  'page.data.body.header_illustration_right.primary.header_illustration_right_illustration': true,
  'page.data.body.header_with_categories.primary.header_categories_picture': true,
  'page.data.body.header_with_topics.primary.header_illustration': true,
  'page.data.body.infinite_slide_track.items.slider_logo': true,
  'page.data.body.quick_presentation.primary.presentation_picture': true,
  'page.data.body.quick_presentation_list.items.presentation_picture': true,
  'page.data.body.quote_card.items.customer_logo': true,
  'page.data.body.webinar_posts.primary.webinar_posts_no_webinar_illustration': true,
  'page.data.body.floating_cards_with_illustrations.items.picture': true,
  'page.data.body.quote_card_list.items.author': true,
  'page.data.body.check_grid.primary.illustration_first_column': true,
  'page.data.body.check_grid.primary.illustration_second_column': true,
  'page.data.body.check_points.primary.check_points_picture': true,
  'page.data.body.grid_with_main_lines.primary.first_illustration': true,
  'page.data.body.grid_with_main_lines.primary.second_illustration': true,
  'page.data.body.quick_presentation_with_callout.primary.quick_pres_with_callout_illustration': true,
  'page.data.body.simple_image.primary.simple_image': true,
  'page.data.body.floating_cards.items.card_illustration': true,
  'quote_generator.data.cart_illustration': true,
  'quote_generator.data.illustration': true,
  'quote_generator.data.wooclap_logo': true,
  'resource.data.illustration': true,
  'localization.data.banner_background': true,
  'localization.data.banner_illustration': true,
  'newsletter.data.illustration': true,
  'newsletter.data.list.custom_illustration': true,
  'glossary.data.illustration': true,
  'page.data.body.spin_the_wheel.primary.catchy_modal_illustration': true,
  'page.data.body.spin_the_wheel.primary.signup_modal_illustration': true,
  'post.data.illustration': true,
  'post.data.body.benchmark_grid.items.column_logo': true,
  'post.data.body.full_width_image.primary.image_content': true,
  'post.data.body.pros_cons_grid.primary.grid_logo': true,
  'post.data.body.simple_grid_with_illustration.items.simple_column_illustration': true,
  'post.data.body.grid_with_grades.items.logo': true,
  'resource.data.body.quote_card.customer_logo': true,
  'resource.data.resource_link': true,
  'tag.data.illustration': true,
  'testimonial.data.illustration': true,
  'testimonial.data.partner_logo': true,
  'testimonial.data.wide_image': true,
  'testimonial.data.body.quick_presentation.primary.presentation_picture': true,
  'woobinar.data.illustration': true,
  'woobinar.data.body.people_cards.items.people_picture': true,
  'pricing.data.testimonial_carousel_person': true,
  'pricing.data.testimonial_carousel_logo': true,
  'pricing.data.testimonial_carousel_illustration': true,
};

module.exports = {
  // The repo name of the Prismic repository
  prismicRepo: 'wooclap-content',

  // Language configuration the Prismic repository
  defaultLanguage: 'en-gb',
  langs: ['fr-fr', 'en-gb', 'es-es', 'de-de', 'it-it'],

  // Prismic documents
  downloadedFiles: downloadedFiles,
};
